import firebase from 'firebase'
var config = { /* COPY THE ACTUAL CONFIG FROM FIREBASE CONSOLE */
  apiKey: "AIzaSyCxNwkAj3UzN2Nt_qIBf4znIo0UdDARRMI",
  authDomain: "bread-4f707.firebaseapp.com",
  databaseURL: "https://bread-4f707.firebaseio.com",
  projectId: "bread-4f707",
  storageBucket: "bread-4f707.appspot.com",
  messagingSenderId: "333949693918"
};
var fire = firebase.initializeApp(config);
export default fire;


// WEBPACK FOOTER //
// ./src/fire.js